import React, { Component } from 'react'
import {Button, Form, Grid, Header, Message, Segment} from 'semantic-ui-react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'
import LoginForm from '../forms/auth/LoginForm'

class LoginPage extends Component {
    //access router
    //this.props.history.push('/dashboard')
    
    render() {
        return (
            <div id='login-form'>
                <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Header as='h2' color='teal' textAlign='center'>
                            Log-in to your account
                        </Header>
                        <LoginForm history={this.props.history}/>
                        <Message>
                        Forget Your Password? <Link to='/auth/forget-password'>Reset Password</Link>
                        </Message>
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

LoginPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
};

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)


// WEBPACK FOOTER //
// ./src/components/auth/Login.js